import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thirtytwoseaterbusonrentinshirdi() {



    const cardData = {





keyword: "32 Seater Bus on Rent in Shirdi",
headingDescription: "Sai Shirdi Cab offers reliable 32 seater bus rental in Shirdi for large groups planning comfortable outstation journeys, religious tours, family trips, corporate travel, school and college tours, weddings, events, and multi-day sightseeing programs. A 32 seater bus provides practical seating capacity for bigger groups traveling together, helping passengers stay organized instead of arranging multiple cars. From Shirdi, the service can be planned for destinations across Maharashtra and nearby states, with experienced drivers, convenient pickup arrangements, spacious seating, and route-focused travel support. Whether you need a one-way journey, round trip, local-to-outstation combination, or a customized multi-day itinerary, Sai Shirdi Cab can arrange a suitable 32 seater bus rental according to your group size and travel schedule.",

topPlaces: [
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a popular choice for group holidays, family tours, and weekend trips from Shirdi. Renting a 32 seater bus through Sai Shirdi Cab allows a larger group to travel together with convenient seating and coordinated transportation. The bus is well suited for sightseeing plans covering viewpoints, market areas, and nearby attractions without requiring several separate vehicles."
},
{
title: "Bhimashankar",
description: "Bhimashankar makes a suitable outstation destination for religious groups and family travelers departing from Shirdi. A 32 seater bus offers an organized way for larger groups to complete the journey together while keeping the travel arrangements simple. Sai Shirdi Cab can support group transportation for temple visits, return journeys, and customized Maharashtra pilgrimage routes."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves can be included in a heritage and sightseeing itinerary from Shirdi for families, student groups, tour groups, and cultural travelers. With a 32 seater bus on rent, passengers can remain together throughout the journey and comfortably plan multiple sightseeing stops. Sai Shirdi Cab provides group travel support for one-day and extended outstation tours."
},
{
title: "Goa",
description: "Goa is an excellent long-distance option for groups looking to travel from Shirdi for holidays, celebrations, college trips, or family vacations. A 32 seater bus rental makes group transportation more convenient by providing shared travel for a larger number of passengers. Sai Shirdi Cab can arrange suitable bus travel for one-way, round-trip, and multi-day Goa itineraries."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is an important pilgrimage destination that can be covered as part of a group tour from Shirdi. A 32 seater bus gives devotees and tour groups enough seating capacity to travel together while keeping the itinerary coordinated. Sai Shirdi Cab can arrange comfortable transportation for temple visits, family pilgrimages, and combined routes covering other nearby destinations."
},
{
title: "Bhandardara",
description: "Bhandardara offers a refreshing outstation option for groups planning a nature trip from Shirdi. The destination works well for family outings, friends' trips, corporate excursions, and weekend travel programs. Hiring a 32 seater bus from Sai Shirdi Cab allows everyone to travel in one vehicle and makes it easier to manage group transportation for sightseeing and return travel."
},
{
title: "Saptashrungi",
description: "Saptashrungi can be selected for a spiritual group journey from Shirdi, especially for families, devotees, and organized pilgrimage groups. A 32 seater bus provides the capacity needed for larger groups while reducing the need to coordinate several smaller cabs. Sai Shirdi Cab can arrange group transportation based on the planned departure time, sightseeing schedule, and return requirements."
},
{
title: "Igatpuri",
description: "Igatpuri is a convenient choice for group leisure trips, nature excursions, and weekend travel from Shirdi. A 32 seater bus on rent provides shared transportation for larger families, friends, corporate teams, and tour groups. With Sai Shirdi Cab, the journey can be planned around your preferred pickup, sightseeing schedule, and return timing for a smoother outstation experience."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a suitable destination for group pilgrimage tours starting from Shirdi. A 32 seater bus makes it easier for devotees traveling together to maintain a common itinerary and avoid managing multiple vehicles. Sai Shirdi Cab can arrange comfortable group transportation for temple visits, family tours, and combined pilgrimage packages from Shirdi."
},
{
title: "Nashik",
description: "Nashik provides a versatile outstation route from Shirdi for pilgrimage tours, family travel, business visits, and sightseeing programs. Groups can rent a 32 seater bus from Sai Shirdi Cab when multiple passengers need to travel together on the same schedule. The vehicle is particularly useful for organized tours that combine Nashik with nearby religious, cultural, or leisure destinations."
}
],









"services": [
{
"name": "32 Seater Bus on Rent in Shirdi",
"description": "32 Seater Bus on Rent in Shirdi provides spacious group transportation for families, tourist groups, organizations, and travelers. The bus can be arranged for sightseeing, pilgrimage trips, outstation journeys, airport transfers, events, and customized group travel requirements."
},
{
"name": "32 Seater Bus Rental Shirdi",
"description": "32 Seater Bus Rental Shirdi offers a convenient transportation solution for larger groups requiring comfortable seating capacity. Rental arrangements can be planned according to travel duration, passenger count, luggage requirements, pickup location, destination, and one-way or round-trip travel needs."
},
{
"name": "32 Seater Bus Hire Shirdi",
"description": "32 Seater Bus Hire Shirdi provides private group transportation for planned journeys from Shirdi. The bus can be hired for family outings, tourist tours, weddings, corporate trips, school travel, pilgrimage journeys, events, and outstation transportation."
},
{
"name": "32 Seater Tourist Bus Shirdi",
"description": "32 Seater Tourist Bus Shirdi provides comfortable group transportation for sightseeing and holiday trips. The vehicle can be arranged for Shirdi sightseeing, nearby destinations, multi-day tours, pilgrimage routes, family travel, and customized tourist itineraries."
},
{
"name": "32 Seater Bus Booking Shirdi",
"description": "32 Seater Bus Booking Shirdi allows groups to reserve suitable transportation in advance for planned journeys. Customers can provide travel dates, pickup timing, passenger count, luggage requirements, destination, journey duration, and preferred travel arrangements."
},
{
"name": "32 Seater Bus With Driver Shirdi",
"description": "32 Seater Bus With Driver Shirdi provides chauffeur-driven transportation for groups seeking convenient private travel. The bus can be arranged for sightseeing, pilgrimage tours, weddings, corporate outings, school trips, events, airport transfers, and outstation journeys."
},
{
"name": "32 Seater Bus for Outstation Shirdi",
"description": "32 Seater Bus for Outstation Shirdi is suitable for larger groups planning long-distance travel from Shirdi to different cities and destinations. The journey can be organized according to the route, travel duration, passenger requirements, luggage, pickup location, and selected itinerary."
},
{
"name": "32 Seater Bus for Family Trip Shirdi",
"description": "32 Seater Bus for Family Trip Shirdi offers spacious transportation for extended families and larger groups traveling together. The bus can be arranged for holidays, pilgrimage visits, sightseeing tours, family functions, multi-day trips, and intercity travel from Shirdi."
},
{
"name": "32 Seater Bus for Wedding Shirdi",
"description": "32 Seater Bus for Wedding Shirdi provides group transportation for wedding guests, relatives, and family members. The bus can be arranged for hotel transfers, wedding venues, railway station pickups, guest movement, local transportation, and travel between different wedding functions."
},
{
"name": "32 Seater Bus for Corporate Trip Shirdi",
"description": "32 Seater Bus for Corporate Trip Shirdi provides group transportation for employees, business teams, and corporate travelers. It can be arranged for company outings, conferences, meetings, team activities, airport transfers, intercity travel, and planned corporate itineraries."
},
{
"name": "32 Seater Bus for School Trip Shirdi",
"description": "32 Seater Bus for School Trip Shirdi offers group transportation for students, teachers, and school staff traveling for educational or recreational trips. The bus can be arranged for sightseeing, educational visits, local excursions, pilgrimage travel, and planned outstation school journeys."
},
{
"name": "32 Seater Bus for Pilgrimage Shirdi",
"description": "32 Seater Bus for Pilgrimage Shirdi provides spacious transportation for groups of devotees visiting Shirdi and other religious destinations. The bus can be planned for Sai Baba darshan, temple tours, multi-destination pilgrimage routes, family groups, and customized religious travel schedules."
},
{
"name": "32 Seater Bus for Events Shirdi",
"description": "32 Seater Bus for Events Shirdi provides convenient group transportation for guests and participants attending different events. The bus can be arranged for conferences, exhibitions, functions, parties, social gatherings, corporate events, and transportation between hotels and event venues."
},
{
"name": "32 Seater AC Bus Shirdi",
"description": "32 Seater AC Bus Shirdi provides a comfortable group travel option for passengers looking for air-conditioned transportation. The bus can be arranged for family trips, sightseeing, pilgrimage journeys, corporate travel, weddings, school trips, events, and outstation routes."
},
{
"name": "32 Seater Luxury Bus Shirdi",
"description": "32 Seater Luxury Bus Shirdi offers a premium group transportation option for travelers seeking enhanced comfort during their journey. It can be arranged for weddings, corporate trips, family tours, special events, sightseeing, pilgrimage travel, and longer intercity journeys."
},
{
"name": "32 Seater Bus One Way Shirdi",
"description": "32 Seater Bus One Way Shirdi provides direct group transportation for passengers who require a single journey without arranging a return trip. The bus can be scheduled from the preferred pickup point in Shirdi to the selected destination according to the travel date and group requirements."
},
{
"name": "32 Seater Bus Round Trip Shirdi",
"description": "32 Seater Bus Round Trip Shirdi is suitable for groups planning an onward journey and return to Shirdi. The trip can be organized according to travel dates, stay duration, passenger count, luggage, waiting requirements, destinations, and preferred return schedule."
},
{
"name": "32 Seater Bus Airport Transfer Shirdi",
"description": "32 Seater Bus Airport Transfer Shirdi provides spacious group transportation for airport pickup and drop requirements. The service can be coordinated with flight timings and arranged according to passenger count, luggage, airport location, pickup schedule, and final destination."
},
{
"name": "Affordable 32 Seater Bus Rental Shirdi",
"description": "Affordable 32 Seater Bus Rental Shirdi provides a practical group transportation option for travelers looking for spacious travel while managing their planned budget. Rental arrangements can be selected according to journey distance, passenger count, luggage, travel duration, route, and trip requirements."
},
{
"name": "Best 32 Seater Bus Hire Shirdi",
"description": "Best 32 Seater Bus Hire Shirdi provides spacious private transportation for families, tourist groups, corporate teams, wedding guests, school groups, and pilgrimage travelers. The bus can be hired for local travel, sightseeing, events, airport transfers, and customized outstation itineraries."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides 32 Seater Bus and other suitable group vehicles for transportation from Shirdi. Vehicles can be arranged for family trips, pilgrimage tours, weddings, corporate outings, school trips, sightseeing, events, airport transfers, and outstation journeys according to group requirements."
}
],
"tableData": [
["32 Seater Bus on Rent in Shirdi", "32 Seater Bus Rental Shirdi"],
["32 Seater Bus Hire Shirdi", "32 Seater Tourist Bus Shirdi"],
["32 Seater Bus Booking Shirdi", "32 Seater Bus With Driver Shirdi"],
["32 Seater Bus for Outstation Shirdi", "32 Seater Bus for Family Trip Shirdi"],
["32 Seater Bus for Wedding Shirdi", "32 Seater Bus for Corporate Trip Shirdi"],
["32 Seater Bus for School Trip Shirdi", "32 Seater Bus for Pilgrimage Shirdi"],
["32 Seater Bus for Events Shirdi", "32 Seater AC Bus Shirdi"],
["32 Seater Luxury Bus Shirdi", "32 Seater Bus One Way Shirdi"],
["32 Seater Bus Round Trip Shirdi", "32 Seater Bus Airport Transfer Shirdi"],
["Affordable 32 Seater Bus Rental Shirdi", "Best 32 Seater Bus Hire Shirdi"],
["Sai Shirdi Cabs", "32 Seater Bus on Rent in Shirdi"]
]
,







whychoose: [
{
WhyChooseheading: "32 Seater Bus on Rent in Shirdi for Group Travel",
WhyChoosedescription: "Sai Shirdi Cabs provides 32 Seater Bus rental services in Shirdi for pilgrimage groups, school and college groups, corporate teams, families, tourists, wedding guests, and other large groups. A 32 Seater Bus can be arranged for Sai Baba Darshan, Shirdi sightseeing, religious tours, events, airport and railway station transfers, outstation trips, and multi-day group journeys."
},
{
WhyChooseheading: "Spacious Transportation for Large Groups",
WhyChoosedescription: "A 32 Seater Bus is a suitable transportation option for groups that prefer travelling together in one vehicle. It helps coordinate passengers, luggage, pickup points, hotels, temples, event venues, sightseeing locations, and other destinations without the need to arrange several smaller vehicles."
},
{
WhyChooseheading: "32 Seater Bus for Sai Baba Darshan",
WhyChoosedescription: "Devotees travelling to Shirdi in a large group can rent a 32 Seater Bus for Sai Baba Darshan and visits to nearby religious places. The group journey can be organized around temple schedules, hotel pickups, sightseeing stops, and other pilgrimage destinations included in the planned travel itinerary."
},
{
WhyChooseheading: "32 Seater Bus for Shirdi Sightseeing",
WhyChoosedescription: "Tourists and family groups can use a private 32 Seater Bus for sightseeing in Shirdi and nearby attractions. The travel plan can include multiple stops based on the group's preferred destinations, available time, pickup location, sightseeing requirements, and planned departure and return schedule."
},
{
WhyChooseheading: "Airport & Railway Station Group Transfers",
WhyChoosedescription: "Sai Shirdi Cabs can arrange 32 Seater Bus transportation for larger groups requiring airport and railway station pickup or drop services. Group transfers can be planned between railway stations, airports, hotels, temples, event venues, and other locations according to passenger arrival and departure schedules."
},
{
WhyChooseheading: "32 Seater Bus Hire for Weddings & Events",
WhyChoosedescription: "A 32 Seater Bus can be booked for wedding guests, family functions, receptions, religious programs, corporate events, conferences, parties, and other gatherings in Shirdi. Shared group transportation can be planned between hotels, venues, railway stations, parking areas, and other event-related locations."
},
{
WhyChooseheading: "Outstation & Multi-Day Bus Tours from Shirdi",
WhyChoosedescription: "Groups can consider a 32 Seater Bus for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Trimbakeshwar, Shani Shingnapur, and other tourist or pilgrimage locations. Multi-day tours, family trips, religious circuits, and multi-city journeys can also be planned according to the required route and itinerary."
},
{
WhyChooseheading: "Book 32 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs",
WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage requirements, rental duration, sightseeing or event plans, and one-way or round-trip requirement with Sai Shirdi Cabs. Based on your group travel schedule, a suitable 32 Seater Bus arrangement can be planned for your Shirdi journey."
}
]

};

const faqData = [
{
question: "Can I rent a 32 Seater Bus in Shirdi?",
answer: "Yes, Sai Shirdi Cabs provides 32 Seater Bus rental services in Shirdi for pilgrimage groups, tourists, families, corporate teams, wedding guests, and other large groups."
},
{
question: "Is a 32 Seater Bus suitable for Sai Baba Darshan?",
answer: "Yes, a 32 Seater Bus can be arranged for large groups travelling to Sai Baba Temple and nearby pilgrimage destinations according to their planned travel itinerary."
},
{
question: "Can I book a 32 Seater Bus for Shirdi sightseeing?",
answer: "Yes, groups can book a private 32 Seater Bus for Shirdi sightseeing and nearby attractions based on their preferred destinations, travel duration, and sightseeing schedule."
},
{
question: "Can I book a 32 Seater Bus for airport transfers?",
answer: "Yes, a 32 Seater Bus can be arranged for group airport pickup and drop services according to flight schedules, passenger count, luggage requirements, and the required pickup or drop location."
},
{
question: "Can I book a 32 Seater Bus from Shirdi Railway Station?",
answer: "Yes, group railway station pickup and drop services can be arranged with a 32 Seater Bus according to train schedules and the transportation requirements of your group."
},
{
question: "Can I rent a 32 Seater Bus for a wedding in Shirdi?",
answer: "Yes, a 32 Seater Bus can be booked for wedding guests, family members, receptions, religious functions, and other event transportation requirements in Shirdi."
},
{
question: "Can I use a 32 Seater Bus for outstation travel?",
answer: "Yes, the bus can be booked for outstation group journeys from Shirdi to different cities, tourist destinations, religious places, and other locations according to your planned route."
},
{
question: "Can I rent a 32 Seater Bus for multiple days?",
answer: "Yes, multi-day 32 Seater Bus rental arrangements can be discussed for extended pilgrimage tours, sightseeing trips, family vacations, corporate tours, group excursions, and multi-city journeys."
},
{
question: "Can a 32 Seater Bus be used for corporate group travel?",
answer: "Yes, companies can consider a 32 Seater Bus for employee transportation, corporate events, conferences, meetings, group outings, official tours, and other business travel requirements depending on the group size and itinerary."
},
{
question: "How can I book a 32 Seater Bus on Rent in Shirdi?",
answer: "Share your pickup point, destination, travel date, passenger count, luggage details, rental duration, sightseeing or event requirements, and one-way or return preference with Sai Shirdi Cabs to proceed with the 32 Seater Bus booking."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Suresh Pawar",
feedback: "Our family group rented a 32 Seater Bus in Shirdi for Sai Baba Darshan and nearby sightseeing. Having everyone travel together made it easier to manage the group and follow our planned itinerary without arranging multiple cars.",
rating: 5
},
{
id: 2,
name: "Mrs. Kavita Joshi",
feedback: "We arranged a 32 Seater Bus for a group event in Shirdi with guests travelling from different places. The shared bus made hotel, venue, and local transfers much more convenient for our entire group.",
rating: 5
}
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32 Seater Bus on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/32-seater-bus-on-rent-in-shirdi.webp",
  "description":
    "Book a 32 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group transportation. Our 32 Seater Bus is suitable for Sai Baba Darshan, Shirdi sightseeing, family trips, group tours, pilgrimages, weddings, corporate trips, school trips, airport transfers, railway station transfers, and outstation travel. Get a well-maintained bus with a professional driver, convenient pickup and drop locations, affordable rental service, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/32-seater-bus-on-rent-in-shirdi"
  }
};







    return (
        <div>

<Helmet>
  <title>32 Seater Bus on Rent in Shirdi | 32 Seater Bus Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book a 32 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for group travel, Sai Baba Darshan, sightseeing, weddings, corporate trips, school trips and outstation journeys. Get a spacious bus with professional driver and easy booking."
  />

  <meta
    name="keywords"
    content="32 Seater Bus on Rent in Shirdi, 32 Seater Bus Rental Shirdi, 32 Seater Bus Hire Shirdi, 32 Seater Tourist Bus Shirdi, 32 Seater Bus Booking Shirdi, 32 Seater Bus with Driver Shirdi, 32 Seater Bus for Outstation Shirdi, 32 Seater Bus for Family Trip Shirdi, 32 Seater Bus for Wedding Shirdi, 32 Seater Bus for Corporate Trip Shirdi, 32 Seater Bus for School Trip Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Thirtytwoseaterbusonrentinshirdi;